<template>
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
		<div class="container">
			<a class="navbar-brand js-scroll-trigger" href="#page-top">Les métiers de l'informatique</a>
	
			<button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
				Menu
				<i class="fas fa-bars"></i>
			</button>
			
			<div class="collapse navbar-collapse" id="navbarResponsive">
				<ul class="navbar-nav text-uppercase ml-auto">
					<li class="nav-item">
						<a class="nav-link js-scroll-trigger" href="/">Accueil</a>
					</li>	
					  
					<li class="nav-item">
						<a class="nav-link js-scroll-trigger" href="#technicien">Technicien informatique</a>
					</li>
					  
					<li class="nav-item">
						<a class="nav-link js-scroll-trigger" href="#dev_log">Développeur logiciel</a>
					</li>
					  
					<li class="nav-item">
						<a class="nav-link js-scroll-trigger" href="#dev_web">Développeur web</a>
					</li>
					  
					<li class="nav-item">
						<a class="nav-link js-scroll-trigger" href="#admin_reseau">Administrateur réseau</a>
					</li>
					  
					<li class="nav-item">
						<a class="nav-link js-scroll-trigger" href="#dba">Administrateur de DB</a>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</template>

<script>
export default {

}
</script>

<style lang="css">

</style>


